import { css } from 'react-emotion';
import theme from '@lyearn-team/theme-config';

const container = () => css`
  height: 100%;
  width: 100%;
  background: #fff;
`;

const root = isFMOutReachInstance => css`
  text-align: center;
  ${isFMOutReachInstance ? `width: 100%; max-width: 70%;` : `width: 500px;`}
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 160px;
  position: relative;
`;

const logoImage = () => css`
  max-width: 114px;
`;

const subTitle = isFMOutReachInstance => css`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: ${isFMOutReachInstance ? '25px' : 'normal'};
  letter-spacing: normal;
  text-align: center;
  color: #222f42;
`;

const innerPageHeader = () => css`
  padding-top: 27px;
  padding-left: 44px;
`;

const innerPageFooter = () => css`
  position: fixed;
  bottom: 0px;
  height: 60px;
  left: 0;
  background: rgba(224, 233, 240, 0.44);
  font-size: 1.6em;
  line-height: 20px;
  color: #606c7a;
  padding: 0 44px;
  box-sizing: border-box;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const footerText = () => css`
  padding: 0px;
  margin: 0px;
  font-weight: 300;
  line-height: 20px;
  font-size: 16px;
  color: rgba(131, 146, 167, 0.7);
`;

const footerAppleIcon = () => css`
  margin: 0 18px 0 11px;
  color: rgba(131, 146, 167, 0.7);
  font-size: 24px;
  transition: all 0.1s linear;
`;

const footerAndroidIcon = () => css`
  color: rgba(131, 146, 167, 0.7);
  font-size: 24px;
  transition: all 0.1s linear;
`;

const iconContainer = css`
  text-align: center;
  margin-bottom: 3px;
`;

const checkIcon = css`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  margin-right: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  background-color: ${theme.color.dark.emerald};
  margin: 0 auto;
`;
const iconClass = css`
  fill: white;
  width: 25px;
  height: 25px;
`;

export default {
  container,
  root,
  subTitle,
  logoImage,
  innerPageHeader,
  innerPageFooter,
  footerAppleIcon,
  footerAndroidIcon,
  footerText,
  iconContainer,
  checkIcon,
  iconClass
};
